import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { CancelaVotoAssembleia } from "app/models/assembleia/cancelaVotoAssembleia.model";

export abstract class AbVoto extends AppService {
  abstract prefixo: string;
  abstract registrarVoto(itemId: number, opVotoId: number);
  abstract getVotoRealizadoByItem(itemId: number);
  abstract validarExibirCancelarOuFinalizarVotacao(assembleiaId: number);
  abstract finalizarVotacao(assembleiaId: number, tipoVoto: string);
  abstract findAllByFilter(filter: AppFilter);
  abstract verificarSeOUsuarioPodeFinalizarVotos(assembleiaId: number);
  abstract resultadosAssembleiaVotos(assembleiaId: number);
  abstract cancelarVoto(cancelaVotoAssembleia: CancelaVotoAssembleia);
  abstract getRelatorio(assembleiaId: number);
}